var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiStar = function SvgMultiStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#multiStar_svg__a)",
    d: "m6.233 3.109 1.354.486c.133.047.133.24 0 .287l-1.354.487a2.13 2.13 0 0 0-1.266 1.266L4.48 6.99c-.047.133-.24.133-.287 0l-.486-1.354A2.13 2.13 0 0 0 2.44 4.37l-1.353-.487c-.134-.047-.134-.24 0-.287L2.44 3.11a2.13 2.13 0 0 0 1.267-1.267L4.193.49c.047-.134.24-.134.287 0l.487 1.353c.213.587.68 1.053 1.266 1.267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#multiStar_svg__b)",
    d: "m12.013 5.929 1.087.393a.125.125 0 0 1 0 .233l-1.087.394a1.72 1.72 0 0 0-1.02 1.02L10.6 9.055a.125.125 0 0 1-.233 0L9.973 7.97a1.71 1.71 0 0 0-1.02-1.02l-1.086-.394a.125.125 0 0 1 0-.233l1.086-.393a1.71 1.71 0 0 0 1.02-1.02l.394-1.087a.125.125 0 0 1 .233 0l.393 1.087c.174.473.547.846 1.02 1.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#multiStar_svg__c)",
    d: "m6.433 10.115.854.307a.095.095 0 0 1 0 .18l-.854.307c-.373.133-.66.426-.793.793l-.307.853a.095.095 0 0 1-.18 0l-.306-.853a1.32 1.32 0 0 0-.794-.793l-.853-.307a.095.095 0 0 1 0-.18l.853-.307c.374-.133.66-.426.794-.793l.306-.853a.095.095 0 0 1 .18 0l.307.853c.133.373.427.66.793.793"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "multiStar_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(7.119 -22.853 3.166)scale(7.68668 14.9748)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "multiStar_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(7.119 -42.464 60.47)scale(6.18758 12.0543)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "multiStar_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.80034 .59952 -1.16795 9.35176 2.65 9.957)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })))));
};
export default SvgMultiStar;